var Node = require('./Node')

function SymbolNode (name) {
  this.name = name
}

SymbolNode.prototype = Object.create(Node.prototype)

SymbolNode.prototype.type = 'SymbolNode'

module.exports = SymbolNode



//////////////////
// WEBPACK FOOTER
// ./node_modules/mr-parser/lib/node/SymbolNode.js
// module id = C8Yh
// module chunks = 0